import moment from "moment";
import React from "react";
import { Col } from "reactstrap";
import "../../styles/TrapPage.scss";

interface Props {
  date: string;
  instruction: string;
  changed: boolean;

}

const Instruction = ({
  date,
  instruction,
  changed,
}: Props) => {
  const now = moment();
  const changeDue = moment(date);
  if (changeDue.isAfter(now) || changed) return null;
  return (
    <Col>
      <div className="trap-instruction">
        <svg width="33px" height="39px" viewBox="0 0 39 33">
          <path
            fill="#FFF500"
            stroke="black"
            strokeWidth={3}
            d="M3.5,30.8L19.5,3l16,27.8H3.5z"
          />
          <path
            d="M20.5,22.4h-2l-0.3-8.4h2.6L20.5,22.4z M19.5,23.7c0.4,0,0.7,0.1,1,0.4c0.2,0.2,0.4,0.5,0.4,0.9c0,0.4-0.1,0.7-0.4,0.9
            c-0.2,0.2-0.6,0.4-1,0.4c-0.4,0-0.7-0.1-1-0.4c-0.2-0.2-0.4-0.5-0.4-0.9s0.1-0.7,0.4-0.9C18.8,23.9,19.1,23.7,19.5,23.7z"
          />
        </svg>
        <p>{instruction}</p>
      </div>
    </Col>
  );
};

export default Instruction;